import React from 'react'
import ImageZoom from 'react-medium-image-zoom'

export default ({ image }) => {
  if (image === undefined) {
    return <React.Fragment />
  }

  return (
    <div className="event-media media-image">
      <ImageZoom
        image={{
          src: image.source_url,
          alt: image.title,
        }}
        zoomImage={{
          src: image.source_url,
          alt: image.title,
        }}
      />
    </div>
  )
}
